module.exports = __webpack_public_path__ + "img/oidc.fb5c0fab.png";